import React from 'react';
import {
  Formik,
  Form,
} from 'formik';
import { useHistory } from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import {
  resolveTo,
  initFormValues,
} from '~/commons/helpers';

import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpSaveBtn from '~/commons/components/FormHttpSaveBtn.jsx';

const FormResource = ({
  stored,
  schema,
  defaults,
  api,
  children,
  onSubmit = (v) => v,
}) => {
  const history = useHistory();
  const [res, req] = useHttpStatus({
    onSuccess({ data }) {
      if (!stored) {
        history.push(resolveTo(`../${data[0]._id}`));
      }
    },
  });

  return (
    <Formik
      validationSchema={schema}
      initialValues={initFormValues(defaults, stored)}
      onSubmit={async (values, actions) => {
        const { status } = await req({
          method: stored ? 'patch' : 'post',
          url: `${api}${stored ? `/${stored._id}` : ''}`,
          data: onSubmit(values),
        });

        if (status === 'success') {
          actions.setSubmitting(false);
          actions.resetForm({ values });
        }
      }}
    >
      <Form>
        <FormHttpSaveBtn
          res={res}
          className="btn-primary mb-3"
        />
        <FormHttpAlert res={res} />
        {children}
      </Form>
    </Formik>
  );
};

export default FormResource;
